/**
 * SessionExpiredModal
 * Modal que se muestra cuando la sesión expira
 * Permite al usuario volver a iniciar sesión sin perder contexto visual
 */

import { forceLogoutWithRedirect } from '../../services/api'

export default function SessionExpiredModal() {
  const handleRelogin = () => {
    forceLogoutWithRedirect()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay oscuro */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden">
        {/* Header con icono */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-full mb-4">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-white">
            Sesion Expirada
          </h2>
        </div>

        {/* Contenido */}
        <div className="px-6 py-6">
          <p className="text-gray-600 text-center mb-6">
            Tu sesion ha expirado por seguridad. Por favor, inicia sesion nuevamente para continuar.
          </p>

          <button
            onClick={handleRelogin}
            className="w-full bg-gradient-to-r from-primary-600 to-primary-700 hover:from-primary-700 hover:to-primary-800 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            Iniciar Sesion
          </button>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <p className="text-xs text-gray-400 text-center">
            Las sesiones expiran automaticamente por inactividad o despues de 7 dias.
          </p>
        </div>
      </div>
    </div>
  )
}
